import { Button, Col, Row } from "antd";
import { LEARN_IMAGE } from "assets";

import "./styles.scss";

const LearnSection = () => {
  return (
    <section className="learn-section">
      <div className="learn-section-inner container">
        <Row gutter={[20, 40]} align={"middle"}>
          <Col xs={{ span: 24, order: 2 }} md={{ span: 12, order: 1 }}>
            <h2>Learn Something About Us</h2>
            <p className="jakarta-sans-font text-black-subtle font-16">
              At Agape IT, we believe in the power of technology to transform
              businesses. With over 15 years of experience in the IT industry,
              our mission is to deliver reliable, high-quality IT services that
              align with your business objectives. Agape IT was founded on the
              principle of unconditional love for technology and its potential
              to change lives. With a decade of experience, we specialize in
              creating IT strategies that are as empathetic to your business
              needs as they are innovative
            </p>
            <Button type="primary" size="large">
              Learn More
            </Button>
          </Col>
          <Col xs={{ span: 24, order: 1 }} md={{ span: 12, order: 2 }}>
            <div className="learn-image-wrapper">
              <img
                src={LEARN_IMAGE}
                alt="learn-image"
                className="learn-image"
              />
            </div>
          </Col>
        </Row>
      </div>
    </section>
  );
};

export default LearnSection;
